// Copyright (c) Docugami, Inc. All rights reserved.

import { dgFontFamily } from "components/common/Fonts";
import { DocSourcePicker } from "components/storage/DocSourcePicker";
import { ProviderPickerItem } from "components/storage/ProviderPickerItem";
import { ItemTypeFilter, StorageProviderFilePicker } from "components/storage/StorageProviderFilePicker";
import { ProviderId, ProviderItem } from "networking/StorageProviders";
import { useState } from "react";
import styled from "styled-components";

const Subtitle = styled.span`
    padding: 8px 0px;
    font-family: ${dgFontFamily};
    font-weight: 300;
    font-size: 24px;
    line-height: 30px;
    margin-top: 70px;
`;

const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin: auto;
`

export interface ExportDestination {
    item: ProviderItem;
    providerId: ProviderId;
    path: string;
}

export interface ExportDestinationPickerProps {
    onSelected: (item: ExportDestination) => void;
}

export const ExportDestinationPicker = (props: ExportDestinationPickerProps): JSX.Element => {
    const [providerId, setProviderId] = useState<ProviderId | null>(null);

    function onCancel() {
        setProviderId(null);
    }

    function onConfirm(items: ProviderPickerItem[]) {
        setProviderId(null);

        if (items.length > 0) {
            const item = items[0];
            props.onSelected({
                item: item.item,
                providerId: item.providerId,
                path: item.path
            });
        }
    }

    return (
        <>
            <Subtitle>Choose an export destination:</Subtitle>
            <ContentContainer>
                <StorageProviderFilePicker
                    itemTypeFilter={ItemTypeFilter.Folder}
                    providerId={providerId}
                    isOpen={!!providerId}
                    onCancel={onCancel}
                    onConfirm={onConfirm} />
                <DocSourcePicker selectedId={providerId} onSelected={id => setProviderId(id)} />
            </ContentContainer>
        </>
    );
}
